import axios from 'axios';
import { Decrypt } from './encryption';
const dist = true 
export const DIST=dist
export const HTTP = axios.create()
export const BASE_URL = dist ? 'https://acomit.lk:5005/api/' : 'http://192.168.42.143:5005/api/'
export const MAIN_SERVER = dist ? 'acomit.lk' : '192.168.42.143'

export function setAuthToken() {
    let token = JSON.parse(Decrypt(localStorage.user)).token
    HTTP.defaults.headers.Authorization = '';
    delete HTTP.defaults.headers.Authorization;

    if (token) {
        token = token.substring(0, token.length - 3)
        HTTP.defaults.headers.Authorization = `Bearer ${token}`;
    }
}
